import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idade'
})
export class IdadePipe implements PipeTransform {

  transform(dataNascimento: Date | undefined): unknown {
    if (dataNascimento === undefined) {
      return "--";
    }

    const umAnoEmMilisegundos = 365 * 24 * 60 * 60 * 1000;
    const umMesEmMilisegundos = 30 * 24 * 60 * 60 * 1000;
    const umDiaEmMilisegundos = 24 * 60 * 60 * 1000;
    const idadeEmMilisegundos = new Date().getTime() - new Date(dataNascimento).getTime();

    const anos = Math.floor(idadeEmMilisegundos / umAnoEmMilisegundos);
    const meses = Math.floor((idadeEmMilisegundos % umAnoEmMilisegundos) / umMesEmMilisegundos);
    const dias = Math.floor((idadeEmMilisegundos % umMesEmMilisegundos) / umDiaEmMilisegundos);

    const descritivoAnos = anos > 0 ? `${anos} anos` : '';
    const descritivoMeses = meses > 0 ? `${meses} meses` : '';
    const descritivoDias = dias > 0 ? `${dias} dias` : '';

    return [descritivoAnos, descritivoMeses, descritivoDias].filter(Boolean).join(', ');
  }

}
